/** @file targetPoint: a mouse event's position in the viewport's puppet-target pixels. */
import { targetScreenOf } from './targetScreenOf';
import type { ViewportCtx } from './viewportCtx';

/**
 * Client -> CSS px of the canvas box (scaled when the box is drawn at another size than the layout's) -> the puppet
 * target through `targetScreenOf(layout).toTarget` (client px before the first fit).
 */
export function targetPoint(ctx: ViewportCtx, e: MouseEvent): [number, number] {
  const r = ctx.canvas.getBoundingClientRect();
  const l = ctx.camera?.layout() ?? null;
  if (l === null || r.width === 0 || r.height === 0) return [e.clientX - r.left, e.clientY - r.top];
  const css: [number, number] = [((e.clientX - r.left) * l.device[0]) / (r.width * l.fit.dpr), ((e.clientY - r.top) * l.device[1]) / (r.height * l.fit.dpr)];
  return targetScreenOf(l).toTarget(css[0], css[1]);
}
